import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Porder } from '../models/entities/porder';
import { PorderRequest } from '../models/dtos/porder_request';



@Injectable({
  providedIn: 'root'
})
export class ProcurementService {

  constructor(
    private networkService: LeanNetworkService,  
    public userService : UserService) { }


  //------------------------------------------------------------------------------------------------------------------------
  pordersGet(code : string, d1 : Date, d2 : Date, regular : boolean, returns : boolean, excludeClosed  : boolean) : Promise<Porder[]> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    request.dteArg1 = d1;
    request.dteArg2 = d2;
    request.blnArg1 = excludeClosed;
    request.blnArg2 = regular;
    request.blnArg3 = returns;
    
    return new Promise((resolve, reject) => {
        this.networkService.post('sales/procurement/pordersGet', request).then(result => {
          return resolve(result.porders);
        }, error => {
            reject(error);
        });
    });
  }


  //------------------------------------------------------------------------------------------------------------------------
  porderGet(code : string) : Promise<Porder> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    
    return new Promise((resolve, reject) => {
      this.networkService.post('sales/procurement/porderGet', request).then(result => {
          return resolve(result.porder);
        }, error => {
            reject(error);
        });
    });
  }



  //------------------------------------------------------------------------------------------------------------------------
  porderSave(porder : Porder) : Promise<Porder>{
    let request: PorderRequest = new PorderRequest(this.userService.userInfo);
    request.porder = porder;

    return new Promise((resolve, reject) => {
      this.networkService.post('sales/procurement/porderSave', request).then(result => {
            let porder : Porder = result.porder;
            return resolve(porder);         
        });
    });
  }

  

  //------------------------------------------------------------------------------------------------------------------------
  porderReception(porder : Porder) : Promise<Porder>{
    let request: PorderRequest = new PorderRequest(this.userService.userInfo);
    request.porder = porder;

    return new Promise((resolve, reject) => {
      this.networkService.post('sales/procurement/porderReception', request).then(result => {
            return resolve(result.porder);         
        }, error => {
            reject(error);
        });
    });
  }


  //------------------------------------------------------------------------------------------------------------------------
  porderClose(code : string) : Promise<Porder> {
    let request         : BaseRequest = new BaseRequest(this.userService.userInfo);
    request.strArg1 = code;
    
    return new Promise((resolve, reject) => {
      this.networkService.post('sales/procurement/porderClose', request).then(result => {
          return resolve(result.porder);
        }, error => {
            reject(error);
        });
    });
  }


}

